<template>
  <header class="site-header">
    <div class="header-container">
      <!-- Logo -->
      <div class="header-logo">
        <router-link to="/">
          <div class="logo-wrapper">
            <img
              :src="logoUrl"
              alt="神翼轮胎"
              class="logo-image"
              :class="{ loaded: logoLoaded }"
              @load="logoLoaded = true"
            />
          </div>
        </router-link>
      </div>

      <!-- Navigation -->
      <nav class="header-nav">
        <ul class="nav-list">
          <li class="nav-item">
            <router-link to="/" exact class="nav-link">{{ $t('header.home') }}</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/products" class="nav-link">{{ $t('header.products') }}</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/about" class="nav-link">{{ $t('header.about') }}</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/blog" class="nav-link">{{ $t('header.service') }}</router-link>
          </li>
        </ul>
        <!-- Language & Contact -->
        <div class="header-actions">
          <div class="language-selector">
            <a
              href="#"
              :class="{ 'language-link': true, 'active': currentLanguage === 'zh' }"
              @click.prevent="switchLanguage('zh')"
            >
              CN
            </a>
            <span class="language-separator">/</span>
            <a
              href="#"
              :class="{ 'language-link': true, 'active': currentLanguage === 'en' }"
              @click.prevent="switchLanguage('en')"
            >
              EN
            </a>
          </div>

          <div class="contact-button-container">
            <a :href="formattedJumpLink" target="_blank" class="contact-button">{{ $t('header.buyOnline') }}</a>
          </div>

          <div class="qrcode-container">
            <a :href="formattedJumpLink" target="_blank">  

            <div class="qrcode-wrapper">
              <img
                :src="tuhuImageUrl"
                alt="扫码"
                class="qrcode-image"
                :class="{ loaded: qrcodeLoaded }"
                @load="qrcodeLoaded = true"
              />
            </div>
          </a>
          </div>
        </div>
      </nav>
      <!-- 汉堡按钮 -->
      <div class="mobile-menu-toggle" @click="mobileMenuOpen = !mobileMenuOpen">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <!-- 移动端弹出菜单 -->
      <div class="mobile-nav-menu" v-if="mobileMenuOpen">
        <div class="mobile-nav-logo">
          <img :src="logoUrl" alt="神翼轮胎 Logo" />
        </div>
        <ul>
          <li @click="closeMobileMenu"><router-link to="/">{{ $t('header.home') }}</router-link></li>
          <li @click="closeMobileMenu"><router-link to="/products">{{ $t('header.products') }}</router-link></li>
          <li @click="closeMobileMenu"><router-link to="/about">{{ $t('header.about') }}</router-link></li>
          <li @click="closeMobileMenu"><router-link to="/blog">{{ $t('header.service') }}</router-link></li>
        </ul>
        <div class="mobile-lang">
          <button @click="switchLanguage('zh'); closeMobileMenu()" :class="['lang-btn', { active: currentLanguage === 'zh' }]">CN</button>
          <button @click="switchLanguage('en'); closeMobileMenu()" :class="['lang-btn', { active: currentLanguage === 'en' }]">EN</button>
        </div>

        <button class="mobile-menu-close" @click="closeMobileMenu">×</button>
      </div>
    </div>
  </header>
</template>

<script>
import { getHeaderInfo } from '@/api/home';

export default {
  name: 'SiteHeader',
  data() {
    return {
      currentLanguage: this.$i18n ? this.$i18n.locale : 'zh',
      headerInfo: {
        officialWebsiteLogo: '',
        jumpLink: '',
        externalWarIcon: ''
      },
      logoLoaded: false,
      qrcodeLoaded: false,
      mobileMenuOpen: false
    }
  },
  computed: {
    logoUrl() {
      return this.headerInfo.officialWebsiteLogo
        ? process.env.VUE_APP_IMAGE_URL + this.headerInfo.officialWebsiteLogo
        : '@/assets/images/logo-blue.png';
    },
    tuhuImageUrl() {
      return this.headerInfo.externalWarIcon
        ? process.env.VUE_APP_IMAGE_URL + this.headerInfo.externalWarIcon
        : '@/assets/images/tuhu.jpg';
    },
    formattedJumpLink() {
      if (!this.headerInfo.jumpLink) return '#';
      return this.headerInfo.jumpLink.startsWith('http')
        ? this.headerInfo.jumpLink
        : `https://${this.headerInfo.jumpLink}`;
    }
  },
  watch: {
    mobileMenuOpen(val) {
      document.body.style.overflow = val ? 'hidden' : '';
    }
  },
  methods: {
    switchLanguage(lang) {
      if (!this.$i18n) return;

      this.currentLanguage = lang;
      this.$i18n.locale = lang;
      localStorage.setItem('locale', lang);
      this.$router.replace('/');
      window.location.reload();
    },
    async fetchHeaderInfo() {
      try {
        const response = await getHeaderInfo();
        if (response && response.data) {
          this.headerInfo = {
            officialWebsiteLogo: response.data.officialWebsiteLogo,
            jumpLink: response.data.jumpLink,
            externalWarIcon: response.data.externalWarIcon
          };
        }
      } catch (error) {
        console.error('Error fetching header info:', error);
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    }
  },
  created() {
    // 从 localStorage 获取保存的语言设置
    const savedLocale = localStorage.getItem('locale');
    if (savedLocale && this.$i18n) {
      this.currentLanguage = savedLocale;
      this.$i18n.locale = savedLocale;
    }
    this.fetchHeaderInfo();
  }
}
</script>

<style lang="scss" scoped>
.site-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: white;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  position: relative;
  
}

.logo-wrapper,
.qrcode-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  transition: opacity 0.3s ease;

  &.loaded {
    //.image-placeholder {
    //  opacity: 0;
    //}
    img {
      opacity: 1;
    }
  }
}

.logo-wrapper {
  width: 200px;
}
.logo-wrapper img {
  width: 200px;
}

.qrcode-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 4px;
}

.logo-image {
  opacity: 0;
  transition: opacity 0.3s;
}
.logo-image.loaded {
  opacity: 1;
}
.qrcode-image {
  opacity: 0;
  transition: opacity 0.3s;
}
.qrcode-image.loaded {
  opacity: 1;
}

.header-nav {
  position: absolute;
  right: 40px;
  display: flex;
  align-items: center;
  z-index: 10;
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  margin-right: 30px;
}

.nav-item {
  margin: 0 20px;
}

.nav-link {
  font-size: 16px;
  color: #333;
  text-decoration: none;
  font-weight: 500;
  padding: 5px 0;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 0;
    height: 2px;
    background-color: #FFD100;
    transition: width 0.3s ease;
  }

  &:hover, &.router-link-active {
    color: #333;
    &:after {
      width: 100%;
    }
  }
}

.header-actions {
  display: flex;
  align-items: center;
}

.language-selector {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.language-link {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  opacity: 0.7;
  transition: opacity 0.3s;

  &:hover, &.active {
    opacity: 1;
  }
}

.language-separator {
  margin: 0 5px;
  color: #333;
  opacity: 0.7;
}

.contact-button-container {
  margin-right: 20px;
}

.contact-button {
  display: inline-block;
  background-color: #FFD100;
  color: #333;
  padding: 8px 20px;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.3s;

  &:hover {
    background-color: darken(#FFD100, 10%);
  }
}

.qrcode-container {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.loaded .qrcode-image {
  opacity: 1;
}

.image-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: transparent;
}
.spinner {
  width: 32px;
  height: 32px;
  border: 4px solid #eee;
  border-top: 4px solid #FFD100;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}

.mobile-nav-menu {
  display: none;
}

@media (max-width: 768px) {
  .header-nav,
  .header-actions {
    display: none !important;
  }

  .header-container {
    padding: 0 20px 0 0;
  }
  .mobile-menu-toggle {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 28px;
    height: 28px;
    cursor: pointer;
    span {
      display: block;
      height: 5px;
      width: 100%;
      background-color: #1976D2;
      margin-bottom: 5px;
      border-radius: 2px;
      transition: all 0.3s;
    }
  }
  .mobile-nav-menu {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #fff;
    z-index: 2000;
    padding-top: 40px;
    animation: fadeInMenu 0.3s;
    .mobile-nav-logo {
      width: 120px;
      margin: 0 0 20px 20px;
      img {
        width: 100%;
        display: block;
      }
    }
    ul {
      list-style: none;
      padding: 0;
      margin: 0 0 20px 0;
      width: 100%;
      li {
        margin: 12px 0;
        font-size: 22px;
        font-weight: bold;
        letter-spacing: 1px;
        text-align: center;
        a {
          color: #1976D2;
          text-decoration: none;
          padding: 12px 40px;
          border-radius: 8px;
          display: inline-block;
          transition: background 0.2s;
        }
        a:active, a:hover {
          background: #e3f0fd;
        }
      }
    }
    .mobile-lang {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
      button {
        background: none;
        border: none;
        color: #1976D2;
        font-size: 20px;
        margin: 0 18px;
        font-weight: bold;
        border-radius: 6px;
        padding: 6px 18px;
        cursor: pointer;
        &.active {
          background: #1976D2;
          color: #fff;
        }
      }
    }

    .mobile-menu-close {
      position: absolute;
      top: 18px;
      right: 18px;
      font-size: 40px;
      color: #1976D2;
      background: none;
      border: none;
      width: 48px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      border-radius: 50%;
      transition: background 0.2s;
      cursor: pointer;
      font-weight: bold;
    }
    .mobile-menu-close:active, .mobile-menu-close:hover {
      background: #e3f0fd;
    }
  }
}
@keyframes fadeInMenu {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>
